/* eslint-disable no-empty-pattern */
import React, { useState, useEffect } from "react";
import kudaFailureAnimation from "../../../../assets//animation/failure.json";
import Lottie from "react-lottie";
import { useHistory } from "react-router-dom";

export default function RedirectErrorModal({ url, message, headerMsg, noRedirectFn, btnMsg }) {
    const [state, setState] = useState({
        check: false,
        nick: "",
        isStopped: true,
    });
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [stateUrlValue, setStateUrlValue] = useState("");

    function handleAnim() {
        setState({ ...state, isStopped: false });
    }

    useEffect(() => {
        document.body.classList.add("backdrop-init");
        // closeModalOnClick(closeModal);
        return () => {
            document.body.classList.remove("backdrop-init");
        };
    }, []);

    const defaultOptions = {
        loop: false,
        autoplay: false,
        animationData: kudaFailureAnimation,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };

    function redirectUser() {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            history.push(`${stateUrlValue}`);
        }, 1000);
    }

    useEffect(() => {
        setStateUrlValue(url);
        //   cleanup
        return () => {
            setStateUrlValue("");
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="modal">
            <div className="modal modal-sendMoney small-modal modal-backdrop kuda-success--modal fadeIn animated modal-backdrop kuda-failure--modal">
                <div className="modal-content kudaFadeInUp animated">
                    <div className="kuda-modal--content">
                        <h4 className="color-black text-xbold margin-bottom--spacer text-center">
                            {headerMsg ? headerMsg : "An error has occurred!"}
                        </h4>

                        <div className="kuda-modal-illustration">
                            <Lottie
                                options={defaultOptions}
                                height={`100%`}
                                width={`100%`}
                                isStopped={state.isStopped}
                                eventListeners={[
                                    {
                                        eventName: "DOMLoaded",
                                        callback: (anim) => handleAnim(anim),
                                    },
                                ]}
                            />
                        </div>
                        <div className="message-response failure-response--message color-black">
                            {message}
                        </div>
                        <div className="flex justify-between align-center mt-4">
                            <div
                                className={`addAction kuda-cta kuda-cta-md mx-auto add-money cursor-pointer 
            ${loading ? "form-loading" : ""}
            `}
                                onClick={noRedirectFn ? noRedirectFn : redirectUser}
                            >
                                <span>{btnMsg ? btnMsg : "Continue"}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
